module.exports = __webpack_public_path__ + "static/media/upload-type-img.69d83d11.png";